import type {ExtractPropsWithoutRef} from '@/types';

import styled from '@emotion/styled';
import {useBreakpointUp} from '@travel-frontend/core';
import {noop} from 'lodash';
import {forwardRef} from 'react';

import {CloseButton} from '@/components/CloseButton';
import {LayoutContainer} from '@/components/LayoutContainer';
import {Container} from '@/components/SearchBar/components/Container';

type Props = ExtractPropsWithoutRef<typeof Container> & {
  onClose?: () => void;
};

export const SearchBar = styled(
  forwardRef<HTMLDivElement, Props>(function SearchBarComponent(
    {children, onClose = noop, ...restProps},
    ref
  ) {
    const lgUp = useBreakpointUp('lg');

    if (lgUp) {
      return (
        <Container {...restProps} ref={ref}>
          <LayoutContainer>{children}</LayoutContainer>
        </Container>
      );
    }

    return (
      <Container {...restProps} ref={ref}>
        {children}
        <CloseButton onClick={() => onClose()} />
      </Container>
    );
  })
)``;
